import React__default from 'react';
import 'react/jsx-runtime';
import Check from '../../../node_modules/@zooplus/icons/dist/es/components/Check.js';
import InfoCircle from '../../../node_modules/@zooplus/icons/dist/es/components/InfoCircle.js';
import TruckShipping from '../../../node_modules/@zooplus/icons/dist/es/components/TruckShipping.js';
import { P1, P2 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { formatMoney } from '../../../utils/utils.js';
import styles from './ShippingFees.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const ShippingFees = (props) => {
    const { site, locale } = useSiteContext();
    const { t } = useTranslation(site.realm);
    return (React__default.createElement("div", { className: styles.shippingFees },
        React__default.createElement("div", { className: styles.shippingFeesRow },
            React__default.createElement("div", { className: styles.shippingFeesTitle },
                React__default.createElement(TruckShipping, null),
                React__default.createElement(P1, { className: styles.noMargin }, t('checkout.preview.delivery'))),
            React__default.createElement("div", { className: styles.shippingFeesAmount }, props.shippingFees == 0 ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Check, { className: styles.freeIcon }),
                React__default.createElement(P1, { className: styles.noMargin }, t('checkout.preview.free-shipping').toUpperCase()))) : (React__default.createElement(P1, { className: styles.noMargin }, formatMoney(props.shippingFees, props.currency, locale))))),
        props.moneyLeftToFreeShipping > 0 && (React__default.createElement("div", { className: `${styles.shippingFeesRow} ${styles.shippingNotification}` },
            React__default.createElement(InfoCircle, null),
            React__default.createElement(P2, { className: styles.shippingFeesText }, t('checkout.cart-offer.shipping-fees', {
                money: formatMoney(props.moneyLeftToFreeShipping, props.currency, locale),
            }))))));
};

export { ShippingFees };
//# sourceMappingURL=ShippingFees.js.map
